import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import UnderlinedText, {
  IUnderlinedTextProps,
} from '@/components/UnderlinedText';

export interface IFormUnderlinedTextProps
  extends Omit<IUnderlinedTextProps, 'onClick'> {
  name: string;
  value: any;
}

const FormUnderlinedText: FC<IFormUnderlinedTextProps> = ({
  name,
  value,
  ...props
}) => {
  const { setValue } = useFormContext() ?? {};
  return setValue ? (
    <UnderlinedText
      onClick={() =>
        setValue(name, value, {
          shouldValidate: true,
          shouldTouch: true,
          shouldDirty: true,
        })
      }
      {...props}
    />
  ) : (
    <span {...props} />
  );
};

export default FormUnderlinedText;
